export default __webpack_public_path__ + "static/brand-colors-dark-d34b9be312813f62eee28bf6c0bb6afd.png";